import en from '../translations/locale/en';
import th from '../translations/locale/th';

export default {
  en,
  th,
};